/* eslint-disable react/display-name */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  Tabs,
  Row,
  Col,
  message,
  Select,
  TreeSelect,
  Table,
  Input,
  InputNumber,
  notification,
  Popconfirm,
  Form,
} from 'antd';
import { SettingOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Icon } from '@ohif/ui';
import * as api from './api';
import './WindowLevelPreferences.styl';

const { Option } = Select;
const EditableCell = ({
  editing,
  dataIndex,
  title,
  examOptionsTree,
  record,
  index,
  children,
  siteHandel,
  isRequired,
  ...restProps
}) => {
  // const onchangehandl = e => {
  //   if (e) {
  //     setCheckNick(false);
  //   } else {
  //     setCheckNick(true);
  //   }
  //   siteHandel();
  // };
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: isRequired,
              message: `请选至少关联中一条映射数据!`,
            },
          ]}
        >
          <TreeSelect
            style={{ width: '100%' }}
            // value={this.state.value}
            value={record.lesionsOptionsId || null}
            // onChange={e => (record.lesionsOptionsId = e)}
            allowClear
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeData={examOptionsTree}
            treeNodeLabelProp="showTitle"
            placeholder="请选择部位"
            onChange={siteHandel}
          // treeDefaultExpandAll
          />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
const CoreDefine = ({ id, item, onChange }) => {
  //病症
  const [defaultValue, setDefaultValue] = useState('');
  // const [pageOne, setPageOne] = useState(true);
  const [isSave, setIsSave] = useState(true);
  const [dialog, setDialog] = useState(false); // 弹窗显示
  const [loading, setLoading] = useState(false);
  const { TabPane } = Tabs;
  const [lesionsOptions, setLesionsOption] = useState([]); // 系统病变/器官分割
  const [syslesionsOptions, setSyslesionsOptions] = useState([]); // 参照病灶
  const [sysExamOptions, setSysExamOptions] = useState([]); // 参照器官分割
  const [lesionsSelectOptions, setLesionsSelectOptions] = useState([]);
  const [lesionsList, setLesionsList] = useState([]);
  // 选择的病变
  const [defaultLesion, setDefaultLesion] = useState('');
  const [lesionsItem, setLesionsItem] = useState({});
  const [isExam, setIsExam] = useState(false); // 是否是器官分割
  //参考病变ID
  const [referenceLesionsId, setReferenceLesionsId] = useState();
  const [optionsSave, setOptionsSave] = useState(true); // 病变属性是否新增
  const [resultItems, setResultItems] = useState([]); // 病变结果列表
  /********************AI辅助标注******************************************************** */

  const [form] = Form.useForm();
  //默认激活页面
  const [defaultAIAssistKey, setDefaultAIAssistKey] = useState('0');
  const [isQuery, setIsQuery] = useState(true); // 是否为第一次进入页面  控制数据初始化
  const [aiToolTitle, setAiToolTitle] = useState([]); //AI辅助工具tabs数据
  const [aiItems, setAiItems] = useState([]);
  const [isRequired, setIsRequired] = useState(true); //form表单 控制是否显示必填

  const [aiToolOptions, setAiToolOptions] = useState(); //AI辅助工具select
  const [aiAssistValue, setAiAssistValue] = useState({ id: null, name: '' }); //AI辅助工具默认值
  const [tabId, setTabId] = useState(''); //当前选中的AI辅助工具id
  const [lesionOptions, setLesionOptions] = useState(); //病变select
  const [lesionValue, setLesionValue] = useState({ id: null, isExam: false }); //病变默认值
  // const [currentAiAssist, setCurrentAiAssist] = useState(''); //当前选中
  const [examOptionsTree, setExamOptionsTree] = useState([]);
  const [attributes, setAttributes] = useState([]); //api传入的数据 原封不动的传回
  // const [isDialogOpen, setisDialogOpen] = useState(false); //控制删除提示弹窗
  const { confirm } = Modal;
  // const [diseaseDefaultValue, setDiseaseDefaultValue] = useState(null); // 列表选中项目

  /**************************END**********************************************************/
  //默认激活页面
  const [defaultActiveKey, setDefaultActiveKey] = useState('1');

  // 病变结果定义----------
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // 列表选中项目key列表
  const [expandedRowKeys, setExpandedRowKeys] = useState([]); // 展开项目key
  const [examExpandKeys, setExamExpandKeys] = useState([]); // 器官分割展开key

  // 病变定义表单数据-------------------------------
  // 通用修改下拉
  const selectHandle = (index, key, value) => {
    const lesionsSetting = Object.assign([], lesionsList);
    lesionsSetting[index][key] = value;
    setLesionsList(lesionsSetting);
  };
  // 病变（对象）
  const diseaseName = (text, record, index) => {
    if (record.referenceId) {
      return record.name;
    } else {
      return (
        <Input
          value={record.name}
          placeholder="请输入病变"
          onChange={e => {
            lesionsObjChange(e, index);
          }}
        />
      );
    }
  };
  const outline = (text, record, index) => {
    if (record.referenceId || record.id) {
      return record.isOutline === 0 ? '是' : '否';
    } else {
      return (
        <Select
          value={record.isOutline}
          onChange={e => selectHandle(index, 'isOutline', e)}
        >
          <Option value={0}>是</Option>
          <Option value={1}>否</Option>
        </Select>
      );
    }
  };
  const isTag = (text, record, index) => {
    if (record.referenceId || record.id) {
      return record.isTag === 0 ? '是' : '否';
    } else {
      return (
        <Select
          value={record.isTag}
          onChange={e => selectHandle(index, 'isTag', e)}
        >
          <Option value={0}>是</Option>
          <Option value={1}>否</Option>
        </Select>
      );
    }
  };
  const sortingType = (text, record, index) => {
    if (record.referenceId || record.id) {
      return record.sortingType === 0 ? '层面升序' : '层面降序';
    } else {
      return (
        <Select
          value={record.sortingType}
          onChange={e => selectHandle(index, 'sortingType', e)}
        >
          <Option value={0}>层面升序</Option>
          <Option value={1}>层面降序</Option>
        </Select>
      );
    }
  };
  const isOrgan = (text, record, index) => {
    if (record.referenceId || record.id) {
      return record.isExam ? '是' : '否';
    } else {
      return (
        <Select
          value={record.isExam}
          onChange={e => selectHandle(index, 'isExam', e)}
        >
          <Option value={true}>是</Option>
          <Option value={false}>否</Option>
        </Select>
      );
    }
  };
  const operation = (text, record, index) => {
    if (record.available) {
      return (
        <Popconfirm
          title="确认删除当前数据"
          onConfirm={() => {
            if (record.id) {
              // 调接口
              api
                .delLesions({
                  imageDataScienceId: id,
                  lesionId: record.id,
                  isExam: record.isExam,
                })
                .then(res => {
                  if (res.status === 'success') {
                    getLesionsList();
                  }
                });
            } else {
              const lesionsSetting = Object.assign([], lesionsList);
              lesionsSetting.splice(index, 1);
              setLesionsList(lesionsSetting);
            }
          }}
          okText="是"
          cancelText="否"
        >
          <Button type="text">删除</Button>
        </Popconfirm>
      );
    } else {
      return '';
    }
  };
  // 病变列表表头
  const columns = [
    {
      title: '序号',
      render: (_text, _record, index) => `${index + 1}`,
    },
    {
      title: '病变（对象）',
      with: 120,
      render: diseaseName,
    },
    {
      title: '勾勒轮廓',
      render: outline,
    },
    {
      title: '标签',
      render: isTag,
    },
    {
      title: '排序方式',
      render: sortingType,
    },
    {
      title: '器官分割',
      render: isOrgan,
    },
    {
      title: '操作',
      render: operation,
    },
  ];

  const initArr = useCallback(
    data => {
      let arr = data.map(item => {
        let obj = {
          title: item.name,
          showTitle: '部位:' + item.name,
          value: item.id.toString(),
          disabled: item.disabled,
        };
        if (item.children) {
          obj.children = initArr(item.children);
        }
        return obj;
      });
      return arr;
    },
    [initArr]
  );
  const aiColumns = [
    {
      title: '序号',
      // render: orderNumber,
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: '项目对应AI辅助工具的标签',
      with: 200,
      dataIndex: 'attributeId', //lesionsOptionsId
      editable: true,
    },
    {
      title: 'AI辅助工具标签',
      with: 200,
      dataIndex: 'name',
      key: 'name',
    },
  ];
  // 选择AI辅助工具
  const aiToolHandle = (val, option) => {
    let obj = {
      name: option.label.name,
      id: option.label.id,
      version: option.label.ver,
      type: option.label.type,
      typeName: option.label.typeName,
    };

    // let arr = aiToolTitle.filter(item => item.id === val);
    let isAddTab = true;
    let aIAssistKey = '';
    aiToolTitle.map((item, index) => {
      if (item.id === val) {
        isAddTab = false;
        aIAssistKey = index.toString();
      }
    });
    //没有 新增一个Tab
    if (isAddTab) {
      aiToolTitle.push(obj);
      setAiToolTitle(aiToolTitle);
      setDefaultAIAssistKey((aiToolTitle.length - 1).toString());
      form.setFieldsValue({
        aiAssist: obj.id,
      });
      setTabId('');
      setAiAssistValue(obj);
    } else {
      setDefaultAIAssistKey(aIAssistKey);
      setAiAssistValue(obj);
    }
    setTableData(obj);
  };
  // 选择病变
  const aiLesionHandle = (val, option) => {
    setLesionValue({ id: option.label.id, isExam: option.label.isExam });
    getAttributes(val, true, option.label.isExam);
    // setTableData(1);
  };
  // 删除AI辅助工具
  const delAiTool = (targetKey, action) => {
    confirm({
      title: '确认删除吗？',
      icon: <ExclamationCircleOutlined />,
      content: '',
      onOk() {
        if (targetKey) {
          if (aiToolTitle[targetKey].did) {
            confirmDelMapping(aiToolTitle[targetKey].did);
          } else {
            aiToolTitle.splice(targetKey, 1);
            if (aiToolTitle.length) {
              setIsQuery(true);
            } else {
              setAiItems([]);
              form.resetFields();
              setIsRequired(true);
            }
          }
        } else {
          console.log('数据错误');
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  //弹窗 确定删除
  const confirmDelMapping = value => {
    api.delMapping({ id: value }).then(res => {
      if (res.status === 'success') {
        notification.success({
          message: '删除成功',
          placement: 'bottomRight',
        });
        onChange && onChange();
        setIsQuery(true);
      }
    });
  };

  //设置AI辅助工具列表数据 ()
  const setTableData = val => {
    //aiAssistValue
    api
      .getAiAaDataList({
        aiAaId: val.id,
        imageDataScienceId: id,
        version: val.version,
      })
      .then(res => {
        if (res.status === 'success') {
          let arr = res.data.tags.map((item, idx) => {
            let obj = {};
            obj[idx + 1] = item.lesionsOptionsId
              ? item.lesionsOptionsId.toString()
              : null;
            form.setFieldsValue(obj);
            return {
              key: idx + 1,
              id: item.id,
              name: item.text,
              attributeId: item.attributeId,
              lesionsOptionsId: item.lesionsOptionsId
                ? item.lesionsOptionsId.toString()
                : null,
              isParent: true,
            };
          });
          form.setFieldsValue({
            lesion: res.data.lesionsId ? res.data.lesionsId.toString() : null,
          });
          setAiItems(arr);
          setAttributes(res.data.attributes);
        }
      });
  };

  // 获取系统病变列表
  const getSysLesionsList = useCallback(() => {
    if (id) {
      api.listSystemLesions().then(res => {
        setLesionsOption(res.list);
        let sysl = [],
          sysE = [];
        for (let i = 0; i < res.list.length; i++) {
          if (res.list[i].isExam) {
            sysE.push(res.list[i]);
          } else {
            sysl.push(res.list[i]);
          }
        }
        setSyslesionsOptions(sysl);
        setSysExamOptions(sysE);
      });
    }
  }, [id]);

  // 获取已选择病变列表
  const getLesionsList = useCallback(() => {
    if (id) {
      api.listLesions({ imageDataId: id }).then(res => {
        setLoading(false);
        setLesionsList(
          res.list.map((item, index) => {
            item.key = index + Date.now();
            return item;
          })
        );
        setLesionsSelectOptions(res.list);
        if (res.list && res.list.length) {
          setIsSave(false);
        } else {
          setIsSave(true);
        }
      });
    }
  }, [id]);

  // 选择病变
  const lesionHandle = (val, option) => {
    const lesionsSetting = Object.assign([], lesionsList);
    let lesions = lesionsList.map(data => {
      return data.key;
    });
    if (lesions && lesions.length && lesions.indexOf(val) != -1) {
      message.warning(option.label.name + '已存在，不可重复添加！');
    } else {
      lesionsSetting.push({
        key: option.label.uuid,
        available: true,
        name: option.label.name,
        isExam: option.label.isExam,
        referenceId: option.label.id,
        isOutline: 0,
        isTag: 0,
        sortingType: 0,
        imageDataScienceId: id,
      });
    }
    setLesionsList(lesionsSetting);
  };

  // 保存数据--------------------
  const save = async () => {
    setLoading(true);
    if (defaultActiveKey === '1') {
      let lesionsScienceExams = [],
        lesionsSciences = [];
      for (let i = 0; i < lesionsList.length; i++) {
        const element = lesionsList[i];
        if (element.name === '') {
          notification.error({
            message: '请输入病变对象',
            placement: 'bottomRight',
          });
          setLoading(false);
          return;
        }
        if (element.isExam) {
          lesionsScienceExams.push(element);
        } else {
          lesionsSciences.push(element);
        }
      }
      //病变项新增
      let payload = {
        isSave: isSave,
        lesionsSciences,
        lesionsScienceExams,
        imageDataScienceId: id,
      };
      api.createLesions(payload).then(res => {
        getLesionsList();
        if (res.status == 'success') {
          // message.success('病变保存成功');
          setIsQuery(true);
          notification.success({
            message: '病变保存成功',
            placement: 'bottomRight',
          });
        }
      });
    } else if (defaultActiveKey === '2') {
      const ress = resultItems.map(item => {
        if (selectedRowKeys.indexOf(item.uuid) !== -1) {
          item.checked = true;
          item.type = 1;
          return item;
        } else {
          item.checked = false;
          item.type = 0;
          return item;
        }
      });
      setResultItems(ress);
      //病变结果项新增
      if (!lesionsItem.id) {
        notification.warning({
          message: '请选择病变',
          placement: 'bottomRight',
        });
        return;
      }
      let payload;
      if (!referenceLesionsId) {
        payload = {
          isSave: optionsSave,
          lesionsId: lesionsItem.id,
          imageDataScienceId: id,
        };
        if (isExam) {
          payload.resultItemExamVOS = resultItems.map(item => {
            item.name = item.name || item.projectName;
            item.lesionsScienceExaminationId = lesionsItem.id;
            return item;
          });
        } else {
          payload.resultItemVOS = resultItems;
        }
      } else {
        payload = {
          isSave: optionsSave,
          lesionsId: lesionsItem.id,
          imageDataScienceId: id,
        };
        if (isExam) {
          payload.resultItemExamVOS = resultItems.map(item => {
            item.name = item.name || item.projectName;
            item.lesionsScienceExaminationId = lesionsItem.id;
            return item;
          });
        } else {
          payload.resultItemVOS = resultItems;
        }
      }
      api.createLesionsResultItem(payload).then(res => {
        setLoading(false);
        if (res.status == 'success') {
          getLesionsResultItem(lesionsItem.id, isExam);
          setOptionsSave(false);
          setIsQuery(true);
          // message.success('病变保存成功');
          notification.success({
            message: '病变保存成功',
            placement: 'bottomRight',
          });
        }
      });
    } else if (defaultActiveKey === '3') {
      try {
        await form.validateFields();
      } catch (errorInfo) {
        setLoading(false);
        return;
      }

      let tags = aiItems.map(item => {
        return {
          attributeId: item.attributeId,
          id: item.id,
          lesionsOptionsId: item.lesionsOptionsId,
          text: item.name,
        };
      });
      let data = {
        id: tabId, //当前辅助工具id
        aiaaId: aiAssistValue.id,
        aiaaName: aiAssistValue.name,
        attributes: attributes,
        imageDataScienceId: id,
        lesionsId: lesionValue.id,
        isExam: lesionValue.isExam,
        tags: tags,
        type: aiAssistValue.type,
        typeName: aiAssistValue.typeName,
        ver: aiAssistValue.version,
      };
      api.saveMapping(data).then(res => {
        setLoading(false);
        if (res.status == 'success') {
          notification.success({
            message: '保存成功',
            placement: 'bottomRight',
          });
          onChange && onChange();
          setIsQuery(true);
        }
      });
    }
  };

  // 病变结果数据定义--------------------
  // 查看点击事件
  const expandedHandle = (e, record) => {
    let idx = expandedRowKeys.indexOf(record.key);
    if (idx >= 0) {
      const arr = expandedRowKeys.concat();
      arr.splice(idx, 1);

      setExpandedRowKeys([...arr]);
    } else {
      setExpandedRowKeys([...expandedRowKeys, record.key]);
    }
  };
  // 项目名称
  const projectName = (text, record, index) => {
    if (
      record.available !== null &&
      record.available &&
      !record.lesionsResultReferenceId
    ) {
      return (
        <Input
          type="text"
          value={isExam ? record.name : record.projectName}
          onChange={e => {
            titleChange(e, index);
          }}
        />
      );
    } else {
      return record.projectName || record.name;
    }
  };
  const resIsTag = (text, record, index) => {
    return (
      <Select
        disabled={!record.available}
        value={record.isTag || 0}
        onChange={e => (record.isTag = e)}
      >
        <Option value={0}>是</Option>
        <Option value={1}>否</Option>
      </Select>
    );
  };
  // 属性值表
  const prototypeList = (text, record, index) => {
    if (!isExam) {
      return (
        <Select
          style={{ width: '100%' }}
          mode={record.lesionsResultReferenceId ? 'multiple' : 'tags'}
          onChange={e => {
            addPrototype(e, record, index);
          }}
          value={
            record.optionsSciences && record.optionsSciences.length
              ? record.optionsSciences.map(option => {
                return option.name;
              })
              : []
          }
          maxTagCount={3}
        >
          {record.optionsSciences &&
            record.optionsSciences.map((opts, _j) => {
              return (
                <Option
                  className="optsSci"
                  key={opts.name}
                  disabled={
                    record.lesionsResultReferenceId || !record.available
                  }
                >
                  {opts.name}
                </Option>
              );
            })}
        </Select>
      );
    } else {
      return (
        <Button
          onClick={e => {
            expandedHandle(e, record, index);
          }}
        >
          查看
        </Button>
      );
    }
  };
  // 操作----------
  // 删除
  const resDelete = (record, index) => {
    if (record.id) {
      api
        .delResItem({
          imageDataScienceId: id,
          isExam: record.isExam,
          lesionId: record.id,
          resultItemId: record.id,
        })
        .then(() => {
          getLesionsResultItem(lesionsItem.id, isExam);
        });
    } else {
      const lesionsSetting = Object.assign([], resultItems);
      lesionsSetting.splice(index, 1);
      setResultItems(lesionsSetting);
    }
  };
  const resOperation = (text, record, index) => {
    if (record.available) {
      return (
        <Popconfirm
          title="确认删除当前数据"
          onConfirm={() => {
            resDelete(record, index);
          }}
          okText="是"
          cancelText="否"
        >
          <Button type="text">删除</Button>
        </Popconfirm>
      );
    } else {
      return null;
    }
  };
  // 选择框
  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      // const checkList = selectedRows.map(item => {
      //   console.log(item);
      //   item.checked = true;
      //   item.type = 1;
      //   return item;
      // });
      // const lesionsSetting = Object.assign(
      //   Object.assign(checkList, resultItems),
      //   checkList
      // );
      // setResultItems(lesionsSetting);
    },
    getCheckboxProps: record => ({
      disabled:
        record.lesionsResultReferenceId && record.available ? false : true,
      name: record.name,
    }),
  };
  // 病变结果定义项表头
  const resultColumns = [
    {
      title: '序号',
      render: (_text, _record, index) => `${index + 1}`,
    },
    {
      title: '项目名称',
      with: 120,
      render: projectName,
    },
    {
      title: '是否标注',
      render: resIsTag,
    },
    {
      title: '属性值表',
      render: prototypeList,
    },
    {
      title: '操作',
      render: resOperation,
    },
  ];

  // 获取AI辅助工具Tabs列表数据
  const getAIAssistTabsList = useCallback(
    id => {
      api.getAIAssistTabsList({ imageDataScienceId: id }).then(res => {
        if (res.status === 'success') {
          getListLessonsType(id);
          if (res.data.aiAaIds && res.data.aiAaIds.length) {
            getAttributes(
              res.data.aiAaDetailVO.lesionsId,
              false,
              res.data.aiAaDetailVO.isExam
            );
            let aIAssistKey = '0';
            let list = res.data.aiAaIds.map((i, idx) => {
              if (i.id === res.data.aiAaDetailVO.id) {
                aIAssistKey = idx.toString();
              }
              return {
                name: i.aiaaName,
                id: i.aiaaId,
                version: i.ver,
                type: i.type,
                typeName: i.typeName,
                did: i.id,
              };
            });
            if (aIAssistKey !== defaultAIAssistKey) {
              setDefaultAIAssistKey(aIAssistKey);
            }
            setAiAssistValue(list[0]);
            form.setFieldsValue({
              aiAssist: list[0].id,
            });
            setTabId(res.data.aiAaDetailVO.id);
            setAiToolTitle(list);
            let lesionsId = res.data.aiAaDetailVO.lesionsId.toString();
            // let lesionsId = res.data.aiAaDetailVO.lesionsId;
            form.setFieldsValue({
              lesion: lesionsId,
            });
            setLesionValue({
              id: lesionsId,
              isExam: res.data.aiAaDetailVO.isExam,
            });
            let tags = res.data.aiAaDetailVO.tags.map((item, idx) => {
              let obj = {};
              (obj[idx + 1] = item.lesionsOptionsId
                ? item.lesionsOptionsId.toString()
                : null),
                form.setFieldsValue(obj);
              return {
                key: idx + 1,
                id: item.id,
                name: item.text,
                attributeId: item.attributeId,
                lesionsOptionsId: item.lesionsOptionsId
                  ? item.lesionsOptionsId.toString()
                  : null,
                isParent: true,
              };
            });
            if (tags.length) setIsRequired(false);
            setAiItems(tags);
            setAttributes(res.data.aiAaDetailVO.attributes);
          } else {
            setIsRequired(true);
            setAiAssistValue({ id: null, name: '' });
            setAiToolTitle([]);
            setLesionValue({ id: null, isExam: false });
            setAiItems([]);
            setAttributes([]);
            setTabId('');
            form.resetFields();
          }
        } else {
          console.log('数据错误');
        }
      });
    },
    [defaultAIAssistKey, form, getAttributes, getListLessonsType]
  );

  // 根据所选工具获取病变选项列表
  const getListLessonsType = useCallback(id => {
    let params = {
      isScience: true,
      imageDataScienceId: id,
    };
    api.getListLessonsType(params).then(({ data }) => {
      setLesionOptions(
        data.map(item => ({
          name: item.name,
          id: item.id.toString(),
          isExam: item.isExam,
        }))
      );
      // getAttributes();
    });
  }, []);

  // 根据所选病变获取病变属性
  const getAttributes = useCallback(
    (val, isClearn, isExam) => {
      let params = {
        isScience: true,
        lesionsId: val,
        isExam: isExam,
      };
      api.getAttributes(params).then(({ list }) => {
        if (isClearn) {
          aiItems.map((item, idx) => {
            let obj = {};
            obj[idx + 1] = null;
            form.setFieldsValue(obj);
          });
        }

        setIsRequired(true);
        if (list.length) {
          list.map(item => {
            item.children = item.examOptionsTree;
            item.disabled = true;
          });
          if (isExam) {
            //
            setExamOptionsTree(initArr(list));
          } else {
            let arr = list.map(item => {
              let obj = {
                title: item.name,
                showTitle: item.name,
                value: item.id.toString(),
                disabled: item.disabled,
              };
              if (item.options) {
                obj.children = item.options.map(o => {
                  return {
                    title: o.name,
                    showTitle: item.name + ':' + o.name,
                    value: o.id.toString(),
                    disabled: o.disabled ? true : false,
                  };
                });
              }
              return obj;
            });
            setExamOptionsTree(arr);
          }
        } else {
          setExamOptionsTree([]);
        }
      });
    },
    [aiItems, form, initArr]
  );

  useEffect(() => {
    getSysLesionsList();
    getLesionsList();
  }, [getLesionsList, getSysLesionsList]);

  useEffect(() => {
    // 切换tabs到AI辅助标注页并且页面未加载过数据
    if (defaultActiveKey === '3' && isQuery && dialog) {
      api.getAIAssistList().then(res => {
        let list = res.data.map(item => {
          return {
            id: item.aiaaId,
            name: item.aiaaName,
            ver: item.ver,
            type: item.type,
            typeName: item.typeName,
            // did:item.id
          };
        });
        setAiToolOptions(list);
        setIsQuery(false);
        getAIAssistTabsList(id);
      });
    }
  }, [defaultActiveKey, dialog, getAIAssistTabsList, id, isQuery]);

  // 病变结果项选择病变
  const lesionChange = (val, option) => {
    setLesionsItem(option.label);
    setIsExam(option.label.isExam);
    setDefaultLesion(option.label.id);
    setDefaultValue(''); // 清除参考病变
    setReferenceLesionsId('');
    getLesionsResultItem(option.label.id, option.label.isExam);
  };
  const getLesionsResultItem = (lesionsId, isExam) => {
    api
      .getLesionsResultItem({
        lesionsId,
        isExam,
      })
      .then(({ data, status }) => {
        if (status === 'success') {
          const lriv = data.lesionsResultItemVO; // 普通病灶
          const riev = data.resultItemExamVOS; // 器官分割
          let result = [];
          if (!isExam) {
            result = lriv.map((item, index) => {
              item.key = item.uuid;
              item.isExam = isExam;
              item.checked = item.type == 1 ? true : false;
              return item;
            });
          } else {
            result = riev.map((item, index) => {
              item.key = item.uuid;
              item.optionsSciencesExam = item.optionsSciencesExam || [];
              item.isExam = isExam;
              item.checked = item.type == 1 ? true : false;
              return item;
            });
          }
          const keyList = [];
          for (let i = 0; i < result.length; i++) {
            if (result[i].checked) {
              keyList.push(result[i].key);
            }
          }
          setResultItems(result);
          setSelectedRowKeys(keyList);
          setLoading(false);
        }
      });
  };

  // 病变对象输入
  const lesionsObjChange = (event, key) => {
    const { value } = event.target;
    const lesionsSetting = Object.assign([], lesionsList);
    lesionsSetting[key].name = value;
    setLesionsList(lesionsSetting);
  };
  // 选择参照病变
  const referenceChange = (val, option) => {
    if (id && val) {
      setDefaultValue(val);
      setReferenceLesionsId(val);
      api
        .getReferenceLesionsResultItem({
          lesionsId: option.label.id,
          isExam: option.label.isExam,
        })
        .then(({ data }) => {
          let nresItems = resultItems.concat();
          let uids = resultItems.map(item => {
            return item.uuid;
          });
          if (data.lesionsResultItemVO) {
            const arr = data.lesionsResultItemVO.map((item, index) => {
              item.key = item.uuid;
              item.lesionsIdScience = lesionsItem.id;
              item.lesionsResultReferenceId = id;
              return item;
            });
            for (let i = 0; i < arr.length; i++) {
              if (uids.indexOf(arr[i].uuid) === -1) {
                nresItems.push(arr[i]);
              }
            }
            setResultItems(nresItems);
          } else {
            const arr = data.resultItemExamVOS.map((item, index) => {
              item.key = item.uuid;
              item.projectName = item.name;
              item.lesionsIdScience = lesionsItem.id;
              item.lesionsResultReferenceId = id;
              return item;
            });
            for (let i = 0; i < arr.length; i++) {
              if (uids.indexOf(arr[i].uuid) === -1) {
                nresItems.push(arr[i]);
              }
            }
            setResultItems(nresItems);
          }
        });
    }
  };
  // 清除参照病变
  const referenceClear = () => {
    setDefaultValue('');
    const arr = resultItems.filter(item => {
      if (item.id || item.id === undefined) {
        return item;
      }
    });
    setResultItems(arr);
  };

  // 添加项目
  const addResultItem = () => {
    const lesionsSetting = resultItems.concat();
    let valueList = [];
    let obj = {
      key: Date.now(),
      uuid: Date.now(),
      projectName: '',
      available: true,
      isTag: 0,
      lesionsIdScience: lesionsItem.id,
      lesionsResultReferenceId: null,
      checked: true,
    };
    if (isExam) {
      obj.orders = 0;
      obj.optionsSciencesExam = [];
    } else {
      obj.optionsSciences = [];
      obj.valueList = valueList;
    }
    lesionsSetting.push(obj);
    setResultItems(lesionsSetting);
  };
  // 修改添加结果项定义元素的项目名称
  const titleChange = (e, index) => {
    const { value } = e.target;
    const lesionsSetting = Object.assign([], resultItems);
    lesionsSetting[index].projectName = value;
    lesionsSetting[index].name = value;
    setResultItems(lesionsSetting);
  };
  // 添加属性
  const addPrototype = (e, item, index) => {
    let obj = [];
    if (e && e.length) {
      e.map(i => {
        obj.push({
          name: i,
          lesionsResultScienceId: item.id,
        });
      });
    }
    const lesionsSetting = Object.assign([], resultItems);
    lesionsSetting[index].optionsSciences = obj;
    setResultItems(lesionsSetting);
  };
  // 关闭弹窗
  const closeModal = () => {
    // 关闭弹窗
    console.log('关闭弹窗');
    setDialog(false);
    setIsQuery(true); // 控制查询
    setDefaultValue('');
    setLesionsItem({});
    setResultItems([]);
    setDefaultLesion('');
    // setLesionsSelectOptions([]);
    // setLesionsItem({});
    // setIsExam(false);
  };

  const algorithmType = (_text, record, index) => {
    return (
      <Select
        value={record.algorithmType || 0}
        onChange={e => {
          record.algorithmType = e.target.value;
        }}
      >
        <Option value={0}>识别</Option>
        <Option value={1}>分类</Option>
      </Select>
    );
  };
  const descScience = (_text, record, index) => {
    return (
      <Input
        defaultValue={record.descScience}
        placeholder="请输入描述"
        onChange={e => {
          record.descScience = e.target.value;
        }}
      />
    );
  };
  const levelScience = (_text, record, index) => {
    return (
      <InputNumber
        defaultValue={record.levelScience}
        controls={false}
        placeholder="请输入描述"
        onChange={e => {
          record.levelScience = e.target.value;
        }}
      />
    );
  };
  const suggest = (_text, record, index) => {
    return (
      <Select
        value={record.suggest || 0}
        onChange={e => {
          record.suggest = e.target.value;
        }}
      >
        <Option value={0}>手动</Option>
        <Option value={1}>自动</Option>
        <Option value={2}>自动+手动</Option>
      </Select>
    );
  };
  const examType = (_text, record, index) => {
    return (
      <Select
        value={record.type || 0}
        onChange={e => {
          record.type = e.target.value;
        }}
      >
        <Option value={0}>解剖识别</Option>
      </Select>
    );
  };
  // 展开的树形列表
  const expandedRowRender = (record, index, indent, expanded) => {
    const expandedColumns = [
      {
        title: '器官分割名称',
        render: (_text, rowRecord, j) => {
          if (record.lesionsResultReferenceId) {
            return rowRecord.name;
          } else {
            return (
              <Input
                style={{ width: '150px' }}
                defaultValue={rowRecord.name}
                placeholder="请输入病变"
                onChange={e => {
                  rowRecord.name = e.target.value;
                }}
              />
            );
          }
        },
      },
      {
        title: '算法类型',
        width: 80,
        render: algorithmType,
      },
      {
        title: '描述',
        width: 80,
        render: descScience,
      },
      {
        title: '单元',
        width: 80,
        render: levelScience,
      },
      {
        title: '建议标注方式',
        width: 80,
        render: suggest,
      },
      {
        title: '类型',
        width: 80,
        render: examType,
      },
      {
        title: '操作',
        render: (_text, rowRecord, j) => {
          function dsFilter(dealData, delKey) {
            for (let i = 0; i < dealData.length; i++) {
              if (dealData[i].children && dealData[i].children.length > 0) {
                dealData[i].children = dsFilter(dealData[i].children, delKey);
              }
            }
            return dealData.filter(item => item.uuid !== delKey);
          }
          return (
            <>
              {!record.lesionsResultReferenceId ? (
                <Button
                  type="text"
                  onClick={e => {
                    rowRecord.hasNext = true;
                    rowRecord.children.push({
                      key: Date.now(),
                      uuid: Date.now(),
                      available: true,
                      orders: 0,
                      name: '', // 器官分割名称
                      algorithmType: 0, // 算法类型
                      descScience: '', // 描述
                      levelScience: '', // 单元
                      suggest: '', // 建议标注方式
                      type: '', // 类型
                      children: [],
                    });
                    let aaa = resultItems.concat();
                    setResultItems(aaa);
                    let arr = examExpandKeys.concat();
                    arr.push(rowRecord.uuid);
                    setExamExpandKeys(arr);
                  }}
                >
                  添加子器官
                </Button>
              ) : (
                ''
              )}

              {rowRecord.available ? (
                <Popconfirm
                  title="确认删除当前数据"
                  onConfirm={e => {
                    if (rowRecord.id) {
                      api
                        .delResExamItem({
                          imageDataScienceId: id,
                          optionIds: rowRecord.id,
                          lesionId: record.lesionsScienceExaminationId,
                          resultItemId: rowRecord.id,
                        })
                        .then(() => {
                          getLesionsResultItem(lesionsItem.id, isExam);
                        });
                    } else {
                      record.optionsSciencesExam = dsFilter(
                        record.optionsSciencesExam,
                        rowRecord.uuid
                      );
                      let aaa = resultItems.concat();
                      setResultItems(aaa);
                    }
                  }}
                  okText="是"
                  cancelText="否"
                >
                  <Button type="text">删除</Button>
                </Popconfirm>
              ) : (
                ''
              )}
            </>
          );
        },
      },
    ];
    let examData = resultItems[index].optionsSciencesExam.map(item => {
      return item;
    });
    const onExpand = (expanded, item) => {
      if (expanded) {
        let arr = examExpandKeys.concat();
        arr.push(item.uuid);
        setExamExpandKeys(arr);
      } else {
        let arr = examExpandKeys.concat();
        arr.splice(arr.indexOf(item.uuid), 1);
        setExamExpandKeys(arr);
      }
    };
    return (
      <>
        <Table
          columns={expandedColumns}
          rowKey="uuid"
          dataSource={examData}
          expandable={{
            expandedRowKeys: examExpandKeys,
            onExpand,
          }}
          pagination={false}
        />
        {!record.lesionsResultReferenceId ? (
          <Button
            onClick={e => {
              record.optionsSciencesExam.push({
                uuid: Date.now(),
                available: true,
                name: '', // 器官分割名称
                algorithmType: 0, // 算法类型
                descScience: '', // 描述
                levelScience: '', // 单元
                suggest: '', // 建议标注方式
                type: '', // 类型
                children: [],
              });
              examData.push({
                uuid: Date.now(),
                available: true,
                name: '', // 器官分割名称
                algorithmType: 0, // 算法类型
                descScience: '', // 描述
                levelScience: '', // 单元
                suggest: '', // 建议标注方式
                type: '', // 类型
                hasNext: false, // 是否有子集
                children: [],
              });
              let aaa = resultItems.concat();
              setResultItems(aaa);
            }}
          >
            添加器官分割
          </Button>
        ) : (
          ''
        )}
      </>
    );
  };
  // 展开图标隐藏掉
  const expandIcon = () => {
    return '';
  };

  const mergedColumns = aiColumns.map(col => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: record => ({
        record,
        examOptionsTree,
        isRequired,
        siteHandel: e => {
          record.lesionsOptionsId = e;
          let tags = aiItems.filter(item => item.lesionsOptionsId);
          if (tags.length) {
            setIsRequired(false);
            form.validateFields();
          } else {
            setIsRequired(true);
            form.validateFields();
          }
        },
        dataIndex: record.key,
        title: col.title,
        editing: col.editable,
      }),
    };
  });
  return (
    <>
      {!item || !item.myself ? null : (
        <Button
          type="primary"
          disabled={!id || item.p1 == '1' ? true : false}
          onClick={() => {
            setDialog(true);
          }}
        >
          核心定义表
        </Button>
      )}
      <Modal
        width="1150px"
        visible={dialog}
        maskClosable={false}
        onCancel={closeModal}
        footer={[
          <Button
            key="10"
            onClick={() => {
              setDialog(false);
              setIsQuery(true);
            }}
          >
            取消
          </Button>,
          <Button
            loading={loading}
            key="00"
            type="primary"
            onClick={() => {
              save();
            }}
          >
            保存
          </Button>,
        ]}
      >
        <Tabs
          defaultActiveKey="1"
          activeKey={defaultActiveKey}
          onChange={key => {
            setDefaultActiveKey(key);
          }}
          style={{ overflow: 'initial' }}
        >
          <TabPane tab="病变定义" key="1">
            <p>病变</p>
            <Select style={{ width: 180 }} onChange={lesionHandle}>
              {lesionsOptions &&
                lesionsOptions.map(item => (
                  <Select.Option key={item.uuid} value={item.uuid} label={item}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
            <Table
              style={{ marginTop: '20px' }}
              dataSource={lesionsList}
              rowKey="key"
              columns={columns}
              pagination={false}
            />
            <Button
              style={{ marginTop: '15px' }}
              onClick={() => {
                const lesionsSetting = Object.assign([], lesionsList);
                lesionsSetting.push({
                  key: Date.now(),
                  name: '',
                  available: true,
                  isOutline: 0,
                  isTag: 0,
                  isExam: false,
                  sortingType: 0,
                  imageDataScienceId: id,
                });
                setLesionsList(lesionsSetting);
              }}
            >
              添加病变
            </Button>
          </TabPane>
          <TabPane tab="病变结果项定义" key="2">
            <Row gutter={16}>
              {/* 病变模块 */}
              <Col className="gutter-row" span={8}>
                <div>病变</div>
                <Select
                  value={defaultLesion}
                  style={{ width: 180 }}
                  onChange={lesionChange}
                >
                  {lesionsSelectOptions &&
                    lesionsSelectOptions.map(item => (
                      <Select.Option key={item.id} value={item.id} label={item}>
                        {item.name}
                      </Select.Option>
                    ))}
                </Select>
              </Col>
              {/* 参考病变模块 */}
              <Col className="gutter-row" span={8}>
                <div>参照病变</div>
                <Select
                  value={defaultValue}
                  style={{ width: 180 }}
                  allowClear
                  onChange={referenceChange}
                  onClear={referenceClear}
                >
                  {isExam
                    ? sysExamOptions.map((item, i) => (
                      <Select.Option
                        key={'refer' + item.uuid}
                        value={item.uuid}
                        label={item}
                      >
                        {item.name} {item.isSystem && <SettingOutlined />}
                      </Select.Option>
                    ))
                    : syslesionsOptions.map((item, i) => (
                      <Select.Option
                        key={'refer' + item.uuid}
                        value={item.uuid}
                        label={item}
                      >
                        {item.name} {item.isSystem && <SettingOutlined />}
                      </Select.Option>
                    ))}
                </Select>
              </Col>
            </Row>
            {/* 列表模块 */}
            <Table
              className="res-table"
              style={{ marginTop: '20px' }}
              dataSource={resultItems}
              rowSelection={rowSelection}
              rowKey="uuid"
              expandable={{
                columnWidth: 0,
                expandedRowRender,
                expandedRowKeys,
                expandIcon,
              }}
              columns={resultColumns}
              pagination={false}
            />
            {lesionsItem.id ? (
              <Button
                style={{ marginTop: '15px', textAlign: 'left' }}
                onClick={addResultItem}
              >
                添加项目
              </Button>
            ) : (
              ''
            )}
          </TabPane>

          <TabPane tab="AI辅助标注" key="3">
            <Form layout="vertical" form={form}>
              {/* <Form layout="vertical" form={form2}> */}
              <Form.Item
                label="AI辅助工具"
                name="aiAssist"
                rules={[{ required: true, message: `请选择AI辅助工具!` }]}
              >
                <Select
                  placeholder="请选择AI辅助工具"
                  style={{ width: 180 }}
                  value={aiAssistValue.id}
                  onChange={aiToolHandle}
                >
                  {aiToolOptions &&
                    aiToolOptions.map(item => (
                      <Select.Option key={item.id} value={item.id} label={item}>
                        {item.name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              {aiToolTitle ? (
                <Tabs
                  className="ai-assist"
                  defaultActiveKey="1"
                  activeKey={defaultAIAssistKey}
                  type="editable-card"
                  hideAdd={true}
                  onTabClick={(key, event) => {
                    if (key == defaultAIAssistKey) return;
                    setDefaultAIAssistKey(key);
                    let data = aiToolTitle[key];
                    form.setFieldsValue({ aiAssist: data.id });
                    setTableData({ id: data.id, version: data.version });
                  }}
                  onEdit={delAiTool}
                >
                  {aiToolTitle &&
                    aiToolTitle.map((item, index) => (
                      <TabPane
                        tab={item.name}
                        key={index}
                        closeIcon={
                          <Icon width="14px" height="14px" name={'close'} />
                        }
                      >
                        <Form.Item
                          label="请选择病变"
                          name="lesion"
                          // key={index}
                          rules={[{ required: true, message: `请选择病变!` }]}
                        >
                          <Select
                            placeholder="请选择病变"
                            style={{ width: 180 }}
                            value={lesionValue.id}
                            onChange={aiLesionHandle}
                          >
                            {lesionOptions &&
                              lesionOptions.map(item => (
                                <Select.Option
                                  key={item.id}
                                  value={item.id}
                                  label={item}
                                >
                                  {item.name}
                                </Select.Option>
                              ))}
                          </Select>
                        </Form.Item>

                        <Table
                          components={{
                            body: {
                              cell: EditableCell,
                            },
                          }}
                          style={{ marginTop: '16px' }}
                          dataSource={aiItems}
                          columns={mergedColumns}
                          expandable={{
                            defaultExpandAllRows: true,
                          }}
                          pagination={false}
                        />
                      </TabPane>
                    ))}
                </Tabs>
              ) : (
                ''
              )}
            </Form>
          </TabPane>
        </Tabs>
      </Modal>
    </>
  );
};

export default CoreDefine;

CoreDefine.propTypes = {
  item: PropTypes.object,
  id: PropTypes.number,
  onChange: PropTypes.func,
};
